import Color from 'color';
import colorString from 'color-string';

const PRODUCT_AREA_COLORS = {
  groupColor01: '#ff587e',
  groupColor02: '#ca58c7',
  groupColor03: '#dd4600',
  groupColor04: '#d77a0a',
  groupColor05: '#128297',
  groupColor06: '#008648',
  groupColor07: '#1e43a6',
  groupColor08: '#4570e0',
  groupColor09: '#6825d1',
  groupColor10: '#8852dc',
  groupColorUngrouped: '#6a6c75'
};
function normalizeHex(hex) {
  if (hex.includes('#')) {
    return hex.toUpperCase();
  }
  return `#${hex.toUpperCase()}`;
}
function getAlpha(color) {
  return Color(color).alpha();
}
function toRgbString(_ref) {
  let {
    r,
    g,
    b,
    alpha
  } = _ref;
  return `rgba(${[r, g, b, alpha].join(',')})`;
}
function toHexString(_ref2) {
  let {
    r,
    g,
    b,
    alpha
  } = _ref2;
  if (alpha < 1) {
    const hex = colorString.to.hex([Math.round(r), Math.round(g), Math.round(b), alpha]);
    return {
      hex,
      hex8: hex
    };
  }
  const hex = colorString.to.hex([Math.round(r), Math.round(g), Math.round(b)]);
  return {
    hex,
    hex8: `${hex}FF`
  };
}
function isValidHex(hex) {
  const regex = /(^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$|^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$)/;
  return typeof hex === 'string' && regex.test(hex);
}
function getColor(data) {
  let color;
  if (data && data.hsl) {
    color = Color(data.hsl);
  } else if (data && data.hex && data.hex.length > 0) {
    color = Color(data.hex);
  } else {
    color = Color(data);
  }
  if (data.alpha) {
    color = color.alpha(data.alpha);
  }
  const hsl = color.hsl().object();
  const hsv = color.hsv().object();
  const {
    r,
    g,
    b,
    alpha
  } = color.rgb().object();
  const {
    hex,
    hex8
  } = toHexString({
    r,
    g,
    b,
    alpha
  });
  return {
    r: Math.round(r),
    g: Math.round(g),
    b: Math.round(b),
    alpha: isNaN(alpha) ? 1 : alpha,
    hex,
    hex8,
    hsv,
    hsl
  };
}
function getContrastingColor(hex) {
  if (hex.startsWith('#')) {
    hex = hex.slice(1, hex.length);
  }
  const red = parseInt(hex.substr(0, 2), 16);
  const green = parseInt(hex.substr(2, 2), 16);
  const blue = parseInt(hex.substr(4, 2), 16);
  const yiq = (red * 299 + green * 587 + blue * 114) / 1000;
  if (yiq >= 128) {
    return '#2A2C35';
  }
  return '#FFFFFF';
}

export { PRODUCT_AREA_COLORS, getAlpha, getColor, getContrastingColor, isValidHex, normalizeHex, toHexString, toRgbString };
//# sourceMappingURL=color.js.map
